import React, {useEffect} from 'react';
import {withRouter} from "react-router";
import {Translation, getI18n} from 'react-i18next';
import {Button, Table} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import {ValueAnswerTag, Section1ValueAnswerTag} from '../../../elements/components/Tags';

//import ListActions from '../../../elements/components/ListActions';
import {getColumnSearchProps} from '../../../elements/components/TableColumnFilters';
import {pathTo} from '../../../Routes';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';


const PlannerAnswersList = ({component, page, limit, order, filter, total, load, remove, history, ...props}) => {

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    delete filter[dataIndex];
    history.push(QueryString.append(props.location.pathname, {order, ...filter}));
  };

  const columns = [
    {
      title: getI18n().t('planner_owner_username'),
      dataIndex: 'owner_username',
      key: 'owner_username',
      ...getColumnSearchProps('owner_username', handleSearch, handleReset, getI18n().t('planner_owner_username'), filter),
    },
    {
      title: getI18n().t('planner_answer_number_1'),
      dataIndex: 'answer_value_1',
      key: 'answer_value_1',
      responsive: ['xl'],
      width: 10,
      render: val => <Section1ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('planner_answer_year_born_1'),
      dataIndex: 'answer_year_born_1',
      key: 'answer_year_born_1',
      responsive: ['xl'],
    },
    {
      title: getI18n().t('planner_answer_provided_care_1'),
      dataIndex: 'answer_provided_care_1',
      key: 'answer_provided_care_1',
      responsive: ['xl'],
    },
    {
      title: getI18n().t('planner_answer_number_2'),
      dataIndex: 'answer_value_2',
      key: 'answer_value_2',
      responsive: ['xl'],
      render: val => <ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('planner_answer_number_3'),
      dataIndex: 'answer_value_3',
      key: 'answer_value_3',
      responsive: ['xl'],
      render: val => <ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('planner_answer_number_4'),
      dataIndex: 'answer_value_4',
      key: 'answer_value_4',
      responsive: ['xl'],
      render: val => <ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('planner_answer_number_5'),
      dataIndex: 'answer_value_5',
      key: 'answer_value_5',
      responsive: ['xl'],
      render: val => <ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('planner_answer_number_6'),
      dataIndex: 'answer_value_6',
      key: 'answer_value_6',
      responsive: ['xl'],
      render: val => <ValueAnswerTag value={val} />,
    },
    {
      title: getI18n().t('table_header_actions'),
      dataIndex: 'id',
      key: 'actions',
      render: id =>
      <>
        <Button
          icon={<EyeOutlined />}
          onClick={e => history.push(pathTo('PlannerAnswerViewScreen', {id: id}))}
        />
      </>},
  ];

  const pagination = {
    current: page,
    pageSize: limit,
    total: total,
    showSizeChanger: false,
    position: ['bottomCenter'],
  }

  const handleTableChange = (pagination, filters, sorter) => {

    let path = props.location.pathname;
    const params = {};

    // handle pagination
    if ('current' in pagination && pagination['current']) {
      path = pathTo(component, {page: pagination['current']});
    }

    // handle sorting
    if ('field' in sorter && 'order' in sorter) {
      if (sorter['field'] && sorter['order']) {
        const order = sorter['field'] + '.' + (sorter['order'] === 'ascend' ? 'asc' : 'desc');
        params['order'] = order;
      }
    }

    // handle filters
    if (filters) {
      for (const key in filters) {
        if (filters[key]) {
          params[key] = filters[key].join(',');
        }
      }
    }

    history.push(QueryString.append(path, params));
  }

  const filterString = JSON.stringify(filter);
  useEffect(() => {
    load(page, limit, order, JSON.parse(filterString));
  }, [page, limit, order, filterString, load]);


  return (
    <Translation>{(t) => 
      <Table
        dataSource={props.list}
        columns={columns}
        pagination={page === 1 && total < limit  ? false : pagination}
        loading={props.isLoading}
        scroll={{x: true}}
        onChange={handleTableChange}
      />

      
    }</Translation>
  );
}

export default withRouter(PlannerAnswersList);

Logger.log('silly', `PlannerAnswersList loaded.`);
